export default {
  delegates: (id) => `delegate/delegates/all?eventNo=${id}`,
  registerFingerprint: (id) => `delegate/register/fingerprint?delegateNo=${id}`,
  verifyDelegateFingerprint: (id) =>
    `delegate/register/verifyDelegateFingerprint?delegateNo=${id}`,
};
